import { ConnectedUserComponent } from './../../../shared/connectedUserComponent';
import { Component, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SavedForm } from '../../../classes/savedForm';
import { SavedFormsService } from '../../../services/saved-forms.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Subscription }   from 'rxjs/Subscription';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { DialogService } from '../../../services/dialog.service';
import { SavedFormIdentifier, Modules } from '../../../utils/enumeration';
import { Statique } from '../../../utils/statique';
import { EbDemande } from '../../../classes/demande';
import { ModalService } from '../../../shared/modal/modal.service';

@Component({
	selector: 'app-pricing-mask-filler',
	templateUrl: './pricing-mask-filler.component.html'
})
export class PricingMaskFillerComponent extends ConnectedUserComponent implements OnInit, OnDestroy{

	protected ebModuleNum: number; // numéro du module
	protected ebCompNum: number; // numéro du component
	protected checkDirty: boolean;
	protected subscribedSelectedSf: Subscription;
	protected selectedSavedForm: SavedForm;
	public ebDemande: EbDemande;

	constructor(
		protected savedFormsService: SavedFormsService,
		protected dialogService: DialogService,
		protected modalService: ModalService
	) {

		super();
		this.checkDirty = false;
		this.ebCompNum = SavedFormIdentifier.PRICING_MASK;
		this.ebModuleNum = Modules.PRICING;
	}

	ngOnInit(){
		this.subscribeToSavedFormService();
	}

	subscribeToSavedFormService(){
		// subscribtion to fill savedform
		this.subscribedSelectedSf = this.savedFormsService.selectedSavedForm$.subscribe(function(sf: SavedForm){
			if(sf != null && sf.ebModuleNum == this.ebModuleNum && sf.ebCompNum == this.ebCompNum && sf.ebUser != null && sf.ebUserNum == this.userConnected.ebUserNum){
				this.selectedSavedForm = sf;
				this.fillFormWithSf(sf);
				this.savedFormsService.emitSavedForm(new SavedForm());
			}
		}.bind(this));
	}

	getDemande(): EbDemande{
		return new EbDemande();
	}
	async saveForm(){
		let sf = new SavedForm();

		sf.ebModuleNum = this.ebModuleNum;
		sf.ebCompNum = this.ebCompNum;
		sf.ebUser = this.userConnected;

		if(this.selectedSavedForm){
			sf.ebSavedFormNum = this.selectedSavedForm.ebSavedFormNum
			sf.formName = this.selectedSavedForm.formName;
			sf.dateAjout = this.selectedSavedForm.dateAjout;
		}

		try{
			if(sf.ebSavedFormNum)
				await this.modalService.confirmPromise("Saved search", `Do you want to replace the old saved search ? (${sf.formName})`);
		} catch(e){
			sf.formName = null;
			sf.ebSavedFormNum = null;
			sf.dateAjout = null;
		}

		try{

			let result = await this.dialogService.input(null, 'Name...', sf.formName);
			if(!result) return;

			sf.formName = ""+result;
			sf.formValues = JSON.stringify(this.ebDemande);
			this.savedFormsService.saveSavedForm(sf).subscribe(res => console.log(res));
		}catch(e){
			// on modal dismiss
		}
	}

	// init form with prefilled values if exists
	ngAfterViewInit(){
		if(this.selectedSavedForm && this.selectedSavedForm.ebSavedFormNum)
			this.fillFormWithSf(this.selectedSavedForm);
	}

	fillFormWithSf(sf: SavedForm){
		if(sf && this.ebCompNum == sf.ebCompNum && this.ebModuleNum == sf.ebModuleNum){
			let o, 
				parsedValues: EbDemande = JSON.parse(sf.formValues),
				controls: any; // à voir
			/*
			for(o in parsedValues){
				if(controls[o] && (this.checkDirty && !controls[o].dirty || !this.checkDirty)){
					controls[o].setValue(parsedValues[o]);
				}
			}
			*/
			this.ebDemande = new EbDemande();
			this.ebDemande.cloneData(parsedValues);
		}	
	}

	ngOnDestroy() {
		if(this.subscribedSelectedSf){
			this.subscribedSelectedSf.unsubscribe();
		}
	}

	search(data){
		console.log(data);
	}
}



// WEBPACK FOOTER //
// ./src/app/component/saved-forms/pricing-mask/pricing-mask-filler.component.ts